import { useEffect, useState } from "react";
import { api } from "../lib/api";
import type { WalletProviderStatus } from "../lib/types";

const PROVIDER_LABELS: Record<string, string> = {
  apple: "Apple Wallet",
  google: "Google Wallet",
  samsung: "Samsung Wallet",
};

export default function WalletDiagnostics() {
  const [providers, setProviders] = useState<WalletProviderStatus[] | null>(null);

  useEffect(() => {
    api<{ providers: WalletProviderStatus[] }>("/wallet/status").then((res) => setProviders(res.providers));
  }, []);

  return (
    <div>
      <div className="topbar">
        <div>
          <h1 className="page-title">Wallet Providers</h1>
          <div className="page-subtitle">Configuration status per provider — no secrets are ever shown here</div>
        </div>
      </div>

      {!providers ? (
        <div className="empty-state">Loading…</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 16 }}>
          {providers.map((p) => (
            <div className="card" key={p.provider}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <h3 style={{ margin: 0 }}>{PROVIDER_LABELS[p.provider] ?? p.provider}</h3>
                <span className={`badge badge-${p.status.toLowerCase().replace(/_/g, "-")}`}>{p.status}</span>
              </div>
              {p.message && <p className="muted">{p.message}</p>}
              <ul style={{ paddingInlineStart: 18, margin: 0 }}>
                {p.checks.map((c, i) => (
                  <li key={i} style={{ fontSize: 13, marginBottom: 4 }}>
                    {c.ok === true ? "✓" : c.ok === false ? "✗" : "—"} {c.label}
                    {c.detail ? <span className="muted"> ({c.detail})</span> : null}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
